import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Instance dédiée avec withCredentials — les tokens vivent dans un cookie httpOnly
// posé par le backend, jamais accessibles en JavaScript.
const auth = axios.create({ baseURL: API, withCredentials: true });

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const res = await auth.get(`/auth/me`);
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    fetchMe();
  }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    const res = await auth.post(`/auth/login`, { email, password });
    setUser(res.data.user);
    return res.data;
  }, []);

  const loginEmergent = useCallback(async (session_id) => {
    const res = await auth.post(`/auth/emergent-session`, { session_id });
    setUser(res.data.user);
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    try { await auth.post(`/auth/logout`); }
    catch (e) { if (process.env.NODE_ENV === "development") console.warn("Logout call failed:", e?.message); }
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, logout, loginEmergent, api: API }),
    [user, loading, login, logout, loginEmergent]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
